import { ComponentType } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const NO_PERMISSION_DIALOG_COMPONENT_TYPE: InjectionToken<ComponentType<unknown>> = new InjectionToken<ComponentType<unknown>>('No permission dialog component constructor');

export const NO_PERMISSION_NOTIFICATION_STORAGE_KEY: string = 'cep:noPermissionNotificationPending';
